import Service from "../AuthService"

const graphTypes = {
  getGraphTypes() {
    return Service.get(`/api/graph-type`)
  },
  getGraphTypeById(id) {
    return Service.get(`/api/graph-type/${id}`)
  }
}

export default graphTypes
